import { computed, ref, watch } from 'vue';
import type { EntityCategory, EntitySummary, EntityTemplate } from '../types/entities';
import type { ExportEntry } from '../types/export';
import { exportEntityOrder, sortExportEntries } from '../lib/exportOrdering';

export function useExportOrdering(
  props: {
    entities: EntitySummary[];
    categories: EntityCategory[];
    templates: EntityTemplate[];
    entries: ExportEntry[];
  },
  update: (entries: ExportEntry[]) => void
) {
  const automaticOrder = ref(true);
  const compare = computed(() => exportEntityOrder(props.entities, props.categories, props.templates));
  function sort() {
    const sorted = sortExportEntries(props.entries, props.entities, compare.value);
    if (sorted.some((entry, index) => entry.entityId !== props.entries[index]?.entityId)) update(sorted);
  }
  watch(
    [() => props.entries, compare, automaticOrder],
    () => {
      if (automaticOrder.value) sort();
    },
    { immediate: true }
  );
  function reorder(entries: ExportEntry[]) {
    automaticOrder.value = false;
    update(entries);
  }
  function restoreOrder() {
    automaticOrder.value = true;
    sort();
  }
  return { automaticOrder, reorder, restoreOrder };
}
